import React from 'react';
import CompanyInfo from './footer/CompanyInfo';
import QuickLinks from './footer/QuickLinks';
import ServiceInfo from './footer/ServiceInfo';
import FooterBottom from './footer/FooterBottom';

const Footer: React.FC = () => {
    return (
        <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white mt-auto relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 left-0 w-96 h-96 bg-accent rounded-full -translate-x-48 -translate-y-48"></div>
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-primary rounded-full translate-x-48 translate-y-48"></div>
            </div>

            <div className="container mx-auto px-4 py-12 relative">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <CompanyInfo />
                    <QuickLinks />
                    <ServiceInfo />
                </div>

                <FooterBottom />
            </div>
        </footer>
    );
};

export default Footer;
